module.exports = __webpack_public_path__ + "0996d39c4cf5d223a14559dfa37047fd.woff2";


//////////////////
// WEBPACK FOOTER
// ./assets/Lato-Medium.woff2
// module id = 981
// module chunks = 0